/**
 * A bottom sheet on the phone, a side sheet from `lg` up: the same shape as the trips' routes
 * picker (decision 182). Pass with `side="bottom"`.
 */
export const PHONE_BOTTOM_SHEET = `max-h-[85vh] overflow-y-auto rounded-t-xl lg:inset-x-auto lg:inset-y-0 lg:right-0
  lg:left-auto lg:h-full lg:max-h-none lg:w-[min(420px,88vw)] lg:rounded-none lg:border-l`;

/**
 * The note form on the phone is a full page (U1 board 1.1: with projects, client and files it no
 * longer fits a sheet); from `lg` up today's side panel, wider. Pass with `side="bottom"`.
 */
export const PHONE_FULL_PAGE = `h-[100dvh] max-h-none overflow-y-auto rounded-none lg:inset-x-auto lg:inset-y-0
  lg:right-0 lg:left-auto lg:h-full lg:w-[min(520px,92vw)] lg:border-l`;
